import { useTranslation } from "react-i18next";

import AdminLayout from "../../components/AdminLayout";
import InviteUser from "../../components/AdminLayout/Inviteuser";

export function InviteSignup() {
  return (
    <AdminLayout>
      <InviteUser />
    </AdminLayout>
  );
}

export const Invite = InviteSignup;
